import { render, staticRenderFns } from "./client-transaction-summary.vue?vue&type=template&id=7bc94ac6&scoped=true&"
import script from "./client-transaction-summary.vue?vue&type=script&lang=js&"
export * from "./client-transaction-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc94ac6",
  null
  
)

export default component.exports